/*
Some of these fields are weird for stadmins.

`state.currentPerson.image` -> null for stadmins.
`state.currentPerson.name`  -> ' ' for stadmins

-Ethan, 2020-10-23
*/

export function currentPerson(
  state = {
    dataAccessPolicies: {},
    activeSubscriptionTypes: [],
  },
  action
) {
  switch (action.type) {
    case 'INITIALIZATION_DATA': {
      return action.data.currentPerson || {};
    }
    case 'subscriptionsSlideout/SET_SUBSCRIPTION': {
      const {
        subscription: { subscriptionType, interval, id },
      } = action.data;
      let activeSubscriptionTypes = state.activeSubscriptionTypes;

      if (interval === 'disabled') {
        activeSubscriptionTypes = state.activeSubscriptionTypes.filter(t => t !== subscriptionType);
      } else if (id && !state.activeSubscriptionTypes.includes(subscriptionType)) {
        activeSubscriptionTypes = [...state.activeSubscriptionTypes, subscriptionType];
      }

      return {
        ...state,
        activeSubscriptionTypes,
      };
    }
    default:
      return state;
  }
}

export function getIsHigherUp(state) {
  const { isAdmin, isCompanyAdmin, isManager } = state.currentPerson;
  return !!(isAdmin || isCompanyAdmin || isManager);
}
